import {
  transformDates,
  transformDateStrings,
} from '@/utils/dates/transformDates';

export interface UseStorableState {
  create: <R = Record<string, unknown>, T = unknown>(state: T) => R;
  read: <R = Record<string, unknown>, T = unknown>(state: T) => R;
}

export const useStorableState = (): UseStorableState => {
  const create = <R = Record<string, unknown>, T = unknown>(state: T): R =>
    transformDates(state);

  const read = <R = Record<string, unknown>, T = unknown>(state: T): R =>
    transformDateStrings(state);

  return {
    create,
    read,
  };
};
